module.exports = __webpack_public_path__ + "static/icon-right-circle.c7ae0bf1.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/icon-right-circle.png
// module id = 1019
// module chunks = 2